import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import {
  Cell,
  List,
  Placeholder,
  Section,
  Spinner,
} from "@telegram-apps/telegram-ui";

import { api } from "../api";
import { useAppData } from "../AppData";
import { useBackButton } from "../hooks/useBackButton";
import type { UserInfo } from "../types";

function displayName(u: UserInfo): string {
  const name = [u.first_name, u.last_name].filter(Boolean).join(" ").trim();
  if (name) return name;
  if (u.username) return `@${u.username}`;
  return `ID ${u.tgid}`;
}

export function UsersListPage() {
  const navigate = useNavigate();
  const { me, loading: meLoading } = useAppData();
  const [users, setUsers] = useState<UserInfo[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useBackButton(true, () => navigate("/settings"));

  useEffect(() => {
    if (!me?.is_admin) return;
    api
      .listUsers()
      .then(setUsers)
      .catch((e: unknown) => setError(e instanceof Error ? e.message : String(e)));
  }, [me]);

  if (meLoading) {
    return (
      <div style={{ padding: 32, textAlign: "center" }}>
        <Spinner size="m" />
      </div>
    );
  }

  if (me && !me.is_admin) {
    return <Navigate to="/settings" replace />;
  }

  if (error) {
    return <Placeholder header="Ошибка" description={error} />;
  }

  if (!users) {
    return (
      <div style={{ padding: 32, textAlign: "center" }}>
        <Spinner size="m" />
      </div>
    );
  }

  return (
    <div className="page">
      <List>
        <Section
          header="Пользователи"
          footer="Нажмите на пользователя, чтобы изменить роль и доступ к функциям."
        >
          {users.map((u) => (
            <Cell
              key={u.tgid}
              subtitle={u.username ? `@${u.username} · ID ${u.tgid}` : `ID ${u.tgid}`}
              onClick={() => navigate(`/settings/users/${u.tgid}`)}
              style={{ cursor: "pointer" }}
              after={
                <span className={`role-badge role-badge--${u.role}`}>
                  {u.role === "admin" ? "Админ" : "Юзер"}
                </span>
              }
            >
              {displayName(u)}
            </Cell>
          ))}
        </Section>
      </List>
    </div>
  );
}
